module.exports = __webpack_public_path__ + "img/mx_seguromovil.ccd6c0c7.svg";